import { render } from "./DashboardServerCalls.vue?vue&type=template&id=2c0408e7&scoped=true"
import script from "./DashboardServerCalls.vue?vue&type=script&lang=js"
export * from "./DashboardServerCalls.vue?vue&type=script&lang=js"

import "./DashboardServerCalls.vue?vue&type=style&index=0&id=2c0408e7&lang=scss&scoped=true"
import "./DashboardServerCalls.vue?vue&type=style&index=1&id=2c0408e7&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0408e7"]])

export default __exports__